"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchSummary } from "@repo/design-system/hooks/use-search-summary";
import { useLanguage } from "~/translations/loader/use-language";
import { OptionBadge } from "../filterbar/filters/option-badge-eon";
export function NewsletterSearchSummary() {
  const $ = _c(11);
  const t = useLanguage();
  const {
    options
  } = useSearchSummary();
  let t0;
  if ($[0] !== options.length || $[1] !== t.searchSummary_worldwide) {
    t0 = !options.length && <span className="font-medium">{t.searchSummary_worldwide}</span>;
    $[0] = options.length;
    $[1] = t.searchSummary_worldwide;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.searchSummary_main || $[4] !== t0) {
    t1 = <p className="mr-2 whitespace-nowrap">{t.searchSummary_main}{": "}{t0}</p>;
    $[3] = t.searchSummary_main;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options) {
    t2 = options.length > 0 && <div className="inline-block w-full"><div className="flex flex-wrap items-center gap-2">{options.map(_temp)}</div></div>;
    $[6] = options;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <section className="mb-6 flex min-h-[80px] w-full justify-center border-white border-b bg-transparent"><div className="flex w-full items-center justify-between"><div className="w-full items-center py-2 md:flex">{t1}{t2}</div></div></section>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(option) {
  return <OptionBadge capped={false} key={option.value} onValueRemove={option.onRemove} option={option} />;
}